import { PublishingInitRequest, PublishingJob } from "../Models/PublishingModels";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class PublishingProvider {
    public dataProvider: PublishingProvider | undefined;

    public init() {
        if (!this.dataProvider) {
            this.dataProvider = new PublishingProvider();
        }
    }

    public publishInitSelfHosted(data: PublishingInitRequest): Promise<RespondClient<PublishingJob | string>> {
        return getInstance().post(`${getApiHost()}/api/publishing/self-hosted/init`, data);
    }

    public getSelfHostedJob(id: string): Promise<RespondClient<PublishingJob | string>> {
        return getInstance().get(`${getApiHost()}/api/publishing/self-hosted/jobs/${id}`);
    }
}

export const PublishingProviderInstance = new PublishingProvider();